import axios from "axios";
import { API_URI } from "../../constants/GlobalConstants";
import { CUSTOM_SCHEDULES_FAIL, CUSTOM_SCHEDULES_REQUEST, CUSTOM_SCHEDULES_RESET, CUSTOM_SCHEDULES_SUCCESS, SCHEDULES_FAIL, SCHEDULES_REQUEST, SCHEDULES_RESET, SCHEDULES_SUCCESS } from "../../constants/ScheduleConstants";


export const fetchSchedules = (start, end, view, status) => async (dispatch, getState) => {
  try {
    dispatch({ type: SCHEDULES_REQUEST });

    const {
      userSignIn: { userInfo },
    } = getState();

    const response = await axios.get(`${API_URI}/api/schedules/scheduled-events`, {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      params: {
        startDate: start.toISOString(),
        endDate: end.toISOString(),
        view,
        status,
      },
    });

    dispatch({
      type: SCHEDULES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: SCHEDULES_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const resetSchedules = () => (dispatch) => {
  dispatch({ type: SCHEDULES_RESET });
};

export const fetchCustomSchedules = (start, end, view, status) => async (dispatch, getState) => {
  try {
    dispatch({ type: CUSTOM_SCHEDULES_REQUEST });

    const {
      userSignIn: { userInfo },
    } = getState();

    const response = await axios.get(`${API_URI}/api/schedules/get-c-schedule`, {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      params: {
        startDate: start.toISOString(),
        endDate: end.toISOString(),
        view,
        status,
      },
    });

    dispatch({
      type: CUSTOM_SCHEDULES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: CUSTOM_SCHEDULES_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

// Reset custom schedules
export const resetCustomSchedules = () => (dispatch) => {
  dispatch({ type: CUSTOM_SCHEDULES_RESET });
};